import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function PersonIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00001 9C4.80001 9 3.00001 7.2 3.00001 5V4C3.00001 1.8 4.80001 0 7.00001 0C9.20001 0 11 1.8 11 4V5C11 7.2 9.20001 9 7.00001 9Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.00001 11H5.00001C2.54126 11 0.545176 12.6964 0.0951481 15.0059C-0.0104852 15.548 0.447725 16 1.00001 16H13C13.5523 16 14.0105 15.548 13.9049 15.0059C13.4548 12.6964 11.4588 11 9.00001 11Z"
        />
      </svg>
    </Icon>
  );
}
